import type React from "react"
import { Button } from "@/components/ui/button"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

interface Props {
	onClick: () => void
}

const ShareIcon: React.FC<{ className?: string }> = ({ className }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.75"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		aria-hidden="true"
	>
		<circle cx="18" cy="5" r="3" />
		<circle cx="6" cy="12" r="3" />
		<circle cx="18" cy="19" r="3" />
		<path d="m8.59 13.51 6.83 3.98M15.41 6.51 8.59 10.49" />
	</svg>
)

export function ShareButton({ onClick }: Props) {
	const { locale } = useLocale()
	const t = getTranslations(locale).properties.share
	return (
		<Button
			variant="ghost"
			size="sm"
			onClick={onClick}
			aria-label={t.buttonLabel}
		>
			<ShareIcon className="md:hidden" />
			<span className="hidden md:inline">{t.buttonLabel}</span>
		</Button>
	)
}
